import { Socket } from '@bizzabo/transport';

import { SocketRequest } from './types';

export class QnaAttendeeSocket {
    private questionStatus = () => {};
    private questionAnswered = () => {};
    private questionAnswerLive = () => {};
    private questionAnswer = () => {};
    private questionVote = () => {};
    private questionApprove = () => {};
    private qnaSettingsUpdate = () => {};

    constructor(private socket: Socket) {}

    async onQuestionUpdate(request: SocketRequest) {
        this.questionStatus = await this.socket.subscribe({
            ...request,
            domain: 'qna',
            event: 'QUESTION_STATUS_UPDATE',
        });
        this.questionAnswered = await this.socket.subscribe({
            ...request,
            domain: 'qna',
            event: 'QUESTION_ANSWERED_UPDATE',
        });
        this.questionAnswerLive = await this.socket.subscribe({
            ...request,
            domain: 'qna',
            event: 'QUESTION_ANSWER_LIVE_UPDATE',
        });
        this.questionAnswer = await this.socket.subscribe({
            ...request,
            domain: 'qna',
            event: 'QUESTION_ANSWER_UPDATE',
        });
        this.questionVote = await this.socket.subscribe({
            ...request,
            domain: 'qna',
            event: 'QUESTION_VOTE_UPDATE',
        });
    }

    async onQuestionApprove(request: SocketRequest) {
        this.questionApprove = await this.socket.subscribe({
            ...request,
            domain: 'qna',
            event: 'QUESTION_APPROVE',
        });
    }

    async onSettingsUpdate(request: SocketRequest) {
        this.qnaSettingsUpdate = await this.socket.subscribe({
            ...request,
            domain: 'qna',
            event: 'QNA_SETTINGS_UPDATE',
        });
    }

    close() {
        this.questionStatus();
        this.questionAnswered();
        this.questionAnswerLive();
        this.questionAnswer();
        this.questionVote();
        this.questionApprove();
        this.qnaSettingsUpdate();
    }
}
